import _ from "lodash";
import { useEffect } from "react";

import { IEmployee } from "types/personsTypes";

import { transformDigitToFinancial } from "utils/formatters/transformDigitToFinancial";

interface IProps {
  initialCount?: any;
  editedCount?: any;
  initialStart: any;
  initialEnd: any;
  editedStart: any;
  editedEnd: any;
  //
  initialPaymentDate: any; //paymentDate
  editedPaymentDate: any;
  selectedClosureDateId: any;
  closureDatesOptions: any;
  //workers
  initialWorkers: IEmployee[];
  editedWirkers: IEmployee[];
  defaultWorkersCounts: any;
  //materials
  initialMaterials: any;
  editedMaterials: any;
  //mims
  initialMims: any;
  editedMims: any;
}

export const usePlanWasChanged = ({
  initialCount,
  editedCount,
  editedStart,
  initialStart,
  initialEnd,
  editedEnd,
  //
  initialMaterials,
  editedMaterials,
  //
  initialMims,
  editedMims,
  //
  initialWorkers,
  editedWirkers,
  defaultWorkersCounts,
  //
  selectedClosureDateId,
  initialPaymentDate,
  editedPaymentDate,
  closureDatesOptions,
}: IProps) => {
  const countWasChanged = initialCount !== editedCount;
  const datesWasChanged = editedStart !== initialStart || editedEnd !== initialEnd;

  const initialWorkersIds = initialWorkers?.map((el: any) => ({
    id: el.id,
    count: transformDigitToFinancial(defaultWorkersCounts[el.id]),
  }));
  const editedWirkersIds = editedWirkers?.map((el: any) => ({ id: el.id, count: transformDigitToFinancial(el.count) }));
  const workersWasChanged = !_.isEqual(initialWorkersIds, editedWirkersIds);

  const initialMimsIds = initialMims?.map((el: any) => ({
    id: el.service_id,
    count: transformDigitToFinancial(el.count),
  }));
  const editedMimsIds = editedMims?.map((el: any) => ({ id: el.id, count: transformDigitToFinancial(el.local_count) }));
  const mimsWasChanged = !_.isEqual(initialMimsIds, editedMimsIds);

  const initialMaterialsIds = initialMaterials?.map((el: any) => ({ id: el.material?.id, count: el.count }));
  const editedMaterialsIds = editedMaterials?.map((el: any) => ({ id: el.id, count: el.local_count }));
  const materialsWasChanged = !_.isEqual(initialMaterialsIds, editedMaterialsIds);

  const initialClosureDateId = closureDatesOptions?.find((date: any) => date.payment_date === initialPaymentDate)?.id;
  const closureDateIdWasChanged = initialClosureDateId !== undefined && initialClosureDateId !== selectedClosureDateId;
  const closureDateWasChanged = editedPaymentDate !== undefined && initialPaymentDate !== editedPaymentDate;

  useEffect(() => {
    console.log("usePlanWasChanged", { initialWorkers, editedWirkersIds, workersWasChanged });
  }, [initialWorkers, editedWirkersIds, workersWasChanged]);

  return (
    countWasChanged ||
    datesWasChanged ||
    workersWasChanged ||
    mimsWasChanged ||
    materialsWasChanged ||
    closureDateWasChanged ||
    closureDateIdWasChanged
  );
};
